module.exports = __webpack_public_path__ + "static/img/yi2.96a757c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/yi2.jpg
// module id = Fyb3
// module chunks = 0